import script from "./CopyToClipboard.vue?vue&type=script&lang=ts&setup=true"
export * from "./CopyToClipboard.vue?vue&type=script&lang=ts&setup=true"

import "./CopyToClipboard.vue?vue&type=style&index=0&id=1ac061d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ac061d0"]])

export default __exports__